export const GET_APPOINTMENT_STATUS = 'GET_APPOINTMENT_STATUS';
export const GET_APPOINTMENT_ISSUES_GRAPH = 'GET_APPOINTMENT_ISSUES_GRAPH';
export const GET_APPOINTMENT_ISSUES = 'GET_APPOINTMENT_ISSUES';
